import { useCallback } from 'react';
import { env } from '@/env';

export const useOtpLink = () => {
  const getOtpLink = useCallback((): string | undefined => {
    // Check if there's an OTP token in the URL params
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlOtpLink = urlParams.get('t');

    if (urlOtpLink && env.BRANCH_OTP_URL) {
      try {
        const url = new URL(env.BRANCH_OTP_URL);
        url.searchParams.set('t', urlOtpLink);
        return url.toString();
      } catch {
        // If URL construction fails, return undefined
        return undefined;
      }
    }

    return undefined;
  }, []);

  return { getOtpLink };
};
